import { BOOKINGS_APP_DEF_ID, BOOKINGS_MEMBERS_AREA_WIDGET_ID, MEMBERS_AREA_SECTION_ID, SANTA_MEMBERS_APP_ID } from '../const';
export async function isMemberAreaInstalled(_ref) {
  let {
    wixCodeApi
  } = _ref;
  const membersPublicAPI = await wixCodeApi.site.getPublicAPI(SANTA_MEMBERS_APP_ID);
  return !!(await membersPublicAPI.getSectionUrl({
    widgetId: BOOKINGS_MEMBERS_AREA_WIDGET_ID,
    appDefinitionId: BOOKINGS_APP_DEF_ID,
    sectionId: MEMBERS_AREA_SECTION_ID
  }));
}
//# sourceMappingURL=isMemberAreaInstalled.js.map